module.exports = __webpack_public_path__ + "img/硬件改造建设.6ddf2a43.png";